<template>
    <div :style="$vuetify.breakpoint.smAndDown ? 'margin-top: 65px;' : 'margin-top: 120px;'">
      <v-container fluid>
        <PropertiesView :display="display" source="search" />
      </v-container>
    </div>
</template>

<script>
    import PropertiesView from "@/views/PropertiesView";

    export default {
        name: 'SearchProperties',
        components: {
          PropertiesView
        },
        watch: {
          '$route.params': function() {
            this.initNewSearch();
          },
          '$route.query': function() {
            this.initNewSearch();
          }
        },
        computed: {
            isUserLoggedIn() {
                return this.$store.getters.isUserLoggedIn;
            },
            display() {
                return this.$store.getters.getSearchDisplayType;
            }
        },
      methods: {
          initNewSearch() {
            //reset filters
            this.$store.commit('setCampusId', null);
            this.$store.commit('setStateId', null);
            this.$store.commit('setSearchCity', null);
            this.$store.commit('setCounty', null);
            this.$store.commit('setPropertiesNoPagination', []);

            this.$store.dispatch('setUnitsPerPage', 24);

            if (this.$route.params.type === 'campus') {
              this.$store.commit('setCampusId', this.$route.params.id)
            }

            if (this.$route.params.type === 'state') {
              this.$store.commit('setStateId', this.$route.params.id)
            }

            if (this.$route.params.type === 'city') {
              this.$store.commit('setSearchCity', this.$route.params.id)
              this.$store.commit('setStateId', this.$route.params.state)
            }

            // Handle query params for county filtering
            if (this.$route.query.state) {
              this.$store.commit('setStateId', this.$route.query.state)
            }
            if (this.$route.query.county) {
              this.$store.commit('setCounty', this.$route.query.county)
            }

            this.$store.dispatch(this.isUserLoggedIn ? 'getProperties' : 'getPublicProperties');
          }
      },
      beforeMount() {
        this.initNewSearch();
      }
    }
</script>


<style scoped>
    .search-properties-area {
      margin-top: 80px;
    }
    .container {
      width: 100%;
      padding: 26px 12px 37px;
      margin-right: auto;
      margin-left: auto;
    }
</style>

